var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnVisOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_togggle_vis_off",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_visibility"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7 C14.9455187,7 17.6121853,8.66666667 20,12 C17.6121853,15.3333333 14.9455187,17 12,17 C9.05448133,17 6.38781467,15.3333333 4,12 C6.38781467,8.66666667 9.05448133,7 12,7 Z M12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 Z",
    id: "shape_eye",
    stroke: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVisOff);
export default __webpack_public_path__ + "static/media/icn_vis_off.f8899df45514346b3d24c6b91e3c6bee.svg";
export { ForwardRef as ReactComponent };